import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #NUMERIC INPUT
\*------------------------------------ */
/**
 * 1) Form field that consists of a label, text input, and field note
 */
/** 
 * Numeric Input
 */
.cat-c-numeric-input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

/**
* Stles for numeric input container
*/
.cat-c-numeric-input__container {
  position: relative;
  width: 100%;
}

/**
* Container for medium label, text box and field note
*/
.cat-c-numeric-input__input-container {
  position: relative;
  padding-block: var(--cat-space-x-small);
  padding-inline: var(--cat-space-medium) var(--cat-space-small);
  align-self: stretch;
  border-radius: calc(var(--size-base-unit) * 0.5);
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-form-border);
  height: calc(var(--size-base-unit) * 6);
  display: flex;
  flex-direction: column;
  background: var(--cat-theme-color-form-background);
  /** Background & Border styles for input container on hover state **/
}
.cat-c-numeric-input__input-container input::-webkit-outer-spin-button,
.cat-c-numeric-input__input-container input::-webkit-inner-spin-button {
  display: none;
}
.cat-c-numeric-input__input-container:focus-within {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background: var(--cat-theme-color-form-background);
}
.cat-c-numeric-input__input-container:active:not(:disabled) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background: var(--cat-theme-color-form-background);
}
.cat-c-numeric-input__input-container:hover:not(:disabled) {
  background: var(--cat-theme-color-form-background-hover);
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-form-border-hover);
}
.cat-c-numeric-input--medium .cat-c-numeric-input__input-container {
  height: calc(var(--size-base-unit) * 5);
}
.cat-c-numeric-input--small .cat-c-numeric-input__input-container {
  height: calc(var(--size-base-unit) * 4);
}

/**
* Layout for the label wrap
*/
.cat-c-numeric-input__label-wrap {
  display: flex;
  align-items: center;
  gap: var(--cat-space-3x-small);
  flex: 1 0 0;
  max-width: 100%;
}

/**
* Update the input container css for small size
*/
.cat-c-numeric-input--small .cat-c-numeric-input__input-container {
  --cat-button-padding: var(--cat-space-3x-small);
  padding-block: calc(var(--size-base-unit) * 0.375);
  padding-inline: var(--cat-space-x-small) calc(var(--size-base-unit) * 0.375);
}

.cat-c-numeric-input--large .cat-c-numeric-input__input-container {
  --cat-button-padding: var(--cat-space-3x-small);
  padding-block: calc(var(--size-base-unit) * 0.875);
  padding-inline: calc(var(--size-base-unit) * 1.375) var(--cat-space-small);
}

.cat-c-numeric-input--medium .cat-c-numeric-input__input-container {
  --cat-button-padding: calc(var(--size-base-unit) * 0.625);
  padding-block: calc(var(--size-base-unit) * 0.875);
  padding-inline: calc(var(--size-base-unit) * 1.375) calc(var(--size-base-unit) * 0.875);
}

/*
* numeric input wrapper spacing for medium size 
*/
:is(.cat-c-numeric-input--medium, .cat-c-numeric-input--large) .cat-c-numeric-input__label-wrap {
  margin-block-end: var(--cat-space-x-small);
}

/**
* Stles for label
*/
.cat-c-numeric-input__label {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  color: var(--cat-theme-color-content-default);
  display: flex;
  gap: var(--cat-space-3x-small);
  max-width: 100%;
  /**
   * Medium label
   */
  /**
   * Hide label
   */
}
.cat-c-numeric-input--medium .cat-c-numeric-input__label {
  display: inline-flex;
}
.cat-c-numeric-input__label .cat-c-numeric-input__label-text {
  white-space: normal;
  word-wrap: break-word;
}
.cat-c-numeric-input--hidden-label .cat-c-numeric-input__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/*
* Hide the label wrapper
*/
.cat-c-numeric-input--hidden-label .cat-c-numeric-input__label-wrap {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
* Required text style
*/
.cat-c-numeric-input__label-notation {
  color: var(--cat-theme-color-content-subtle);
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 50%;
  overflow: var(--cat-c-numeric-input-label-notation-overflow, visible);
  /**
   * Medium label Notation
   */
}
.cat-c-numeric-input--disabled .cat-c-numeric-input__label-notation {
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-numeric-input--medium .cat-c-numeric-input__label-notation {
  word-wrap: break-word;
}

/**
* Wrapper style for input
*/
.cat-c-numeric-input__input-wrap {
  display: flex;
  padding-inline-end: 0;
  align-items: center;
  gap: var(--cat-space-3x-small);
  flex: 1 0 0;
  align-self: stretch;
}

/**
* Styles for input box
*/
.cat-c-numeric-input__input {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: -webkit-box;
  line-height: var(--cat-line-height-default, var(--cat-line-height-24));
  font-size: var(--cat-font-size-default, var(--cat-font-size-16));
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  color: var(--cat-theme-color-content-default);
  text-overflow: ellipsis;
  border: none;
  margin: 0;
  padding: 0;
  background: transparent;
}
.cat-c-numeric-input__input:focus {
  outline: none;
}

/*
* Color style update for filling/focussing state
*/
.cat-c-numeric-input__input-container:focus-within .cat-c-numeric-input__input {
  color: var(--cat-theme-color-content-default);
}

/**
* Styles for increment and decrement seperator line
*/
.cat-c-numeric-input__button--seperator-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 var(--cat-space-3x-small);
}

/*
* Styles for button seperator
*/
.cat-c-numeric-input__button--seperator {
  width: calc(var(--size-base-unit) * 0.125);
  background: var(--cat-theme-color-border-default);
  height: calc(var(--size-base-unit) * 3);
}

/**
* Styles for numeric input wrapper
*/
.cat-c-numeric-input__button-wrap {
  display: flex;
  align-items: center;
}

/**
* Styles for increment and decrement button
*/
.cat-c-numeric-input__button {
  display: flex;
  align-items: flex-start;
  gap: calc(var(--size-base-unit) * 1.25);
}

/*
* Styles update for numeric input wrap for small size
*/
.cat-c-numeric-input--small .cat-c-numeric-input__button-wrap {
  inset-block-end: calc(var(--size-base-unit) * 0.125);
}

/**
* Cat icon and individual cat icon wrappers
*/
cat-icon,
.cat-icon {
  /**
  * Cat icon and individual cat icon wrappers within numeric input button
  * 1) Because it's a slot in a slot, icons don't inherit the bare button icon size
  */
}
.cat-c-numeric-input__button cat-icon,
.cat-c-numeric-input__button .cat-icon {
  color: var(--cat-theme-color-content-default);
  font-weight: var(--cat-font-weight-regular);
}

/*
* Styles for button icon
*/
.cat-c-numeric-input__button-icon {
  margin-inline-end: var(--cat-space-x-small);
}

/**
 * Left button
 */
.cat-c-numeric-input__button-left {
  inset-inline-start: calc(var(--size-base-unit) * 0.125);
}

/**
 * Disabled style
 */
.cat-c-numeric-input--disabled {
  cursor: not-allowed;
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
  color: var(--cat-theme-color-content-disabled);
  /**
  * Removed pointer events for numeric input Buttons
  */
  /*
  * Styles for input container
  */
}
.cat-c-numeric-input--disabled .cat-c-numeric-input__input {
  background: var(--cat-theme-color-background-default-disabled);
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-numeric-input--disabled cat-button {
  pointer-events: none;
}
.cat-c-numeric-input--disabled:hover {
  cursor: not-allowed;
}
.cat-c-numeric-input--disabled .cat-c-numeric-input__input-container {
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-colorborder-disabled);
  background: var(--cat-theme-color-background-default-disabled);
  pointer-events: none;
}
.cat-c-numeric-input--disabled .cat-c-numeric-input__label {
  color: var(--cat-theme-color-content-disabled);
  pointer-events: none;
}
.cat-c-numeric-input--disabled cat-field-note {
  color: var(--cat-theme-color-content-disabled);
}

/*
  * Styles for error
  */
.cat-is-error .cat-c-numeric-input__input-container {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
  background: var(--cat-theme-color-form-background);
}
.cat-is-error .cat-c-numeric-input__input-container:hover:not(:disabled) {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
}
.cat-is-error .cat-c-numeric-input__input-container:focus-within {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

.cat-is-error.cat-c-numeric-input--disabled .cat-c-numeric-input__input-container {
  background: var(--cat-theme-color-background-default-disabled);
}

/*
  * Styles for readonly
  */
.cat-is-readonly {
  pointer-events: none;
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
}
.cat-is-readonly .cat-c-numeric-input__input-container {
  border: 1px solid var(--cat-theme-color-border-readonly);
  background: var(--cat-theme-color-form-background);
}
.cat-is-readonly .cat-c-numeric-input__input-container:focus-within {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background: var(--cat-theme-color-form-background);
}
.cat-is-readonly .cat-c-numeric-input__input {
  background: var(--cat-theme-color-form-background);
  color: var(--cat-theme-color-content-subtle);
}

/*
  * Styles for input loading state
  */
.cat-c-numeric-input__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 3);
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
  position: relative;
}
.cat-c-numeric-input__input-loader .cat-c-numeric-input--small {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
}
.cat-c-numeric-input__input-loader .cat-c-numeric-input__button-wrap {
  display: flex;
  align-items: center;
  position: absolute;
  inset-inline-end: var(--cat-space-3x-small);
  inset-block-end: var(--cat-space-x-small);
}

/*
* Styles for loading state
*/
.cat-c-numeric-input--loader .cat-c-numeric-input__button-wrap {
  pointer-events: none;
}
.cat-c-numeric-input--loader .cat-c-numeric-input__footer {
  margin-block-start: var(--cat-space-3x-small);
}
.cat-c-numeric-input--loader .cat-c-numeric-input__label {
  margin-block-end: var(--cat-space-3x-small);
}

.cat-c-numeric-input--large .cat-c-numeric-input__input-loader {
  --cat-button-padding: var(--cat-space-3x-small);
}
.cat-c-numeric-input--large .cat-c-numeric-input__input-loader .cat-c-numeric-input__button-wrap {
  margin-inline-end: var(--cat-space-3x-small);
}

/*
* Style update for loading for medium size
*/
.cat-c-numeric-input--medium .cat-c-numeric-input__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2.5);
  --cat-button-padding: var(--cat-space-3x-small);
}
.cat-c-numeric-input--medium .cat-c-numeric-input__input-loader .cat-c-numeric-input__button-wrap {
  margin-inline-end: var(--cat-space-3x-small);
}

/*
* Style update for loading for small size
*/
.cat-c-numeric-input--small .cat-c-numeric-input__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
  --cat-button-padding: var(--cat-space-3x-small);
}
.cat-c-numeric-input--small .cat-c-numeric-input__input-loader .cat-c-numeric-input__button-wrap {
  inset-block-end: var(--cat-space-3x-small);
}

/*
* Style update for small varient button seperator
*/
.cat-c-numeric-input--small .cat-c-numeric-input__button--seperator {
  height: calc(var(--size-base-unit) * 2.5);
}

.cat-c-numeric-input:not(.cat-c-numeric-input--has-field-note) .cat-c-numeric-input__field-note-wrapper, .cat-c-numeric-input:not(.cat-c-numeric-input--has-error-note) .cat-c-numeric-input__error-note-wrapper, .cat-c-numeric-input:not(.cat-c-numeric-input--has-warning-note) .cat-c-numeric-input__warning-note-wrapper, .cat-c-numeric-input:not(.cat-c-numeric-input--has-suffix) .cat-c-numeric-input__suffix-slot, .cat-c-numeric-input:not(.cat-c-numeric-input--has-after) .cat-c-numeric-input__after-slot {
  display: none;
}
`;
       